import React, { PureComponent } from 'react';
import { values } from 'lodash';
import PropTypes from 'prop-types';

export class Notification extends PureComponent {

  static TYPES = {
    TYPE_ERROR: 'error',
    TYPE_WARNING: 'warning',
    TYPE_SUCCESS: 'success',
    TYPE_MESSAGE: 'message'
  };

  static propTypes = {
    t: PropTypes.func.isRequired,
    title: PropTypes.node,
    message: PropTypes.string,
    type: PropTypes.oneOf(values(Notification.TYPES)),
    linkUrl: PropTypes.string,
    linkMessage: PropTypes.string,
    children: PropTypes.any
  };

  static defaultProps = {
    type: Notification.TYPES.TYPE_MESSAGE
  };

  get title() {
    const { t, title, type } = this.props;

    if (title) {
      return title;
    }

    switch (type) {
      case Notification.TYPES.TYPE_ERROR:
        return t('Error');
      case Notification.TYPES.TYPE_WARNING:
        return t('Warning');
      case Notification.TYPES.TYPE_SUCCESS:
        return t('Success');
      case Notification.TYPES.TYPE_MESSAGE:
        return t('Info');
      default:
        return '';
    }
  }

  get message() {
    const { t, message, type, children } = this.props;

    if (message || children) {
      return message;
    }

    switch (type) {
      case Notification.TYPES.TYPE_ERROR:
        return t('An error has occurred');
      case Notification.TYPES.TYPE_WARNING:
        return t('Warning');
      case Notification.TYPES.TYPE_SUCCESS:
        return t('Success');
      case Notification.TYPES.TYPE_MESSAGE:
        return t('Info');
      default:
        return '';
    }
  }

  get style() {
    switch (this.props.type) {
      case Notification.TYPES.TYPE_ERROR:
        return { backgroundColor: 'rgb(196, 106, 105)' };
      case Notification.TYPES.TYPE_WARNING:
        return { backgroundColor: 'rgb(199, 145, 33)' };
      case Notification.TYPES.TYPE_SUCCESS:
        return { backgroundColor: 'rgb(115, 158, 115)' };
      case Notification.TYPES.TYPE_MESSAGE:
        return { backgroundColor: 'rgb(50, 118, 177)' };
      default:
        return {};
    }
  }

  get icon() {
    switch (this.props.type) {
      case Notification.TYPES.TYPE_ERROR:
        return <i className="fa fa-warning shake animated"/>;
      case Notification.TYPES.TYPE_WARNING:
        return <i className="fa fa-shield fadeInLeft animated"/>;
      case Notification.TYPES.TYPE_SUCCESS:
        return <i className="fa fa-check"/>;
      case Notification.TYPES.TYPE_MESSAGE:
        return <i className="fa fa-bell swing animated"/>;
      default:
        return null;
    }
  }

  hideNotification = () => {
    const notification = document.getElementsByClassName("eskimos-notifications-notice-content");
    const closedLink = document.getElementsByClassName("eskimos-notifications-notice-close");
    while (notification.length > 0) notification[0].remove();
    while (closedLink.length > 0) closedLink[0].remove();
  }

  render() {
    const { linkUrl, linkMessage, children } = this.props;
      return (
        <div
          className="SmallBox animated fadeInRight fast"
          style={this.style}
        >
          <div className="foto">
            {this.icon}
          </div>
          <div className="textoFoto">
            <span>{this.title}</span>
            <p display-if={this.message}>{this.message}</p>

            {children}

            <a
              display-if={linkUrl}
              target="_blank"
              href={linkUrl}
              onClick={() =>this.hideNotification()}
            >
              {linkMessage}
            </a>

            <p/>
          </div>
        </div>
      );
  }

}

export default Notification;
